import AOS from "aos";
import Swiper from "swiper/bundle";
import sharer from "sharer.js";

jQuery(function ($) {
  AOS.init({
    once: true,
    offset: 100,
    duration: 1200,
    easing: "ease",
  });

  var container = $(".projects .container").width(),
    offset = ($(window).width() - container) / 2;

  const projects = new Swiper(".projects__slider", {
    slidesPerView: "auto",
    slidesOffsetBefore: offset,
    spaceBetween: 26,
  });

  const ssgal = new Swiper(".ssgal", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(".faq__title").on("click", function () {
    var faq = $(this).parents(".faq");
    $(faq).find(".faq__answer").slideToggle();
    $(faq).toggleClass("active");
  });

  $(".projects-page__selector li").on("click", function () {
    var filter = $(this).data("filter");
    var title = $(this).find("span").text();
    $(this).addClass("active").siblings().removeClass("active");
    $(".projects-page__section .title").text(title);
    $(".projects-page__item, article.cariera").hide();
    $(filter).fadeIn();
  });

  //file upload button

  const fileChosen = $(".file-upload__file");
  $(".file-upload input").on("change", function () {
    $(".file-upload__file span").text(this.files[0].name);
  });

  $(".burger").on("click", function () {
    $("body").toggleClass("show-menu");
    $(".mobile-menu").fadeToggle();
  });

  $(window).scroll(function () {
    if (!$("body").hasClass("show-menu")) {
      if ($(window).scrollTop() > 50) {
        $("header").addClass("sticky");
      }
      if ($(window).scrollTop() < 50) {
        $(".header").removeClass("sticky");
      }
    }
  });
});
